<template>
  <div
    v-if="relatedLinks.length > 0"
    class="related-links"
  >
    <div
      v-if="header"
      class="related-links__header"
    >
      <slot :name="header" />
    </div>

    <div
      class="related-links__slider splide"
      :js-carousel="id"
    >
      <div class="splide__track">
        <ul
          class="related-links__list splide__list"
          js-related-links="navigation"
        >
          <li
            v-for="(slot, index) in relatedLinks"
            :key="index"
            class="related-links__item splide__slide"
          >
            <slot :name="slot">
              {{ slot }}
            </slot>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Related Links (related-links)
 * --------------------------------------------------------------------------
 *
 */
import Carousel from '~/api/carousel'

export default {
  name: 'RelatedLinks',

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
    }
  },

  computed: {
    relatedLinks() {
      return Object.keys(this.$slots).filter(slot => slot !== 'header')
    },

    header() {
      return Object.keys(this.$slots).find(slot => slot === 'header')
    },
  },

  mounted() {
    if (!this.id) {
      return
    }

    this.createCarousel()
  },

  methods: {

    /**
     * Main carousel contructor function.
     */
    createCarousel() {
      const carousel = Carousel(
        `[js-carousel="${this.id}"]`,
        {
          type: 'slide',
          gap: 2,
          drag: true,
          autoWidth: true,
          padding: {
            left: 'var(--margin-desktop)',
            right: 'var(--margin-desktop)',
          },
          breakpoints: {
            640: {
              padding: {
                left: 'var(--margin-mobile)',
                right: 'var(--margin-mobile)',
              },
            },
          },
        },
      )

      if (!carousel) {
        return
      }

      carousel.mount()

    },
  },
}
</script>
